import { createRoute, createRouter, Navigate } from '@tanstack/react-router';
import LoadingPage from 'components/LoadingPage';
import LoadingScreen from 'components/LoadingScreen';
import { adminTasksRoute } from 'pages/admin/AdminTasks/AdminTasksPage/route';
import { adminAiPromptRoute } from 'pages/admin/AiPrompt/AdminAiPromptPage/route';
import { adminAppointmentNoteTemplatesRoute } from 'pages/admin/AppointmentNoteTemplates/route';
import { adminIndexRoute, adminParentRoute } from 'pages/admin/adminParentRoute';
import { adminClaimRelaunchPlanEditRoute } from 'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlanEditPage/route';
import { adminClaimRelaunchPlanNewRoute } from 'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlanNewPage/route';
import { adminClaimRelaunchPlansRoute } from 'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlansPage/route';
import { adminClaimRoute } from 'pages/admin/Claims/AdminClaimPage/route';
import { adminClaimsRoute } from 'pages/admin/Claims/AdminClaimsPage/route';
import { adminDatamatrixRoute } from 'pages/admin/DatamatrixGenerator/AdminDatamatrixGeneratorPage/route';
import { adminExpiredProductsRequestRoute } from 'pages/admin/ExpiredProductsRequests/AdminExpiredProductsRequestPage/route';
import { adminExpiredProductsRequestsRoute } from 'pages/admin/ExpiredProductsRequests/AdminExpiredProductsRequestsPage/route';
import { adminFaksRoute } from 'pages/admin/Faks/AdminFaksPage/route';
import { adminGroupNewRoute } from 'pages/admin/Groups/AdminGroupNewPage/route';
import { adminGroupRoute } from 'pages/admin/Groups/AdminGroupPage/route';
import { adminGroupsRoute } from 'pages/admin/Groups/AdminGroupsPage/route';
import { adminGroupsLabsRoute } from 'pages/admin/GroupsLabs/AdminGroupsLabsPage/route';
import { adminHomeRoute } from 'pages/admin/Home/AdminHomePage/route';
import { adminImpersonateRoute } from 'pages/admin/Impersonate/AdminImpersonatePage/route';
import { adminInboundMailsRoute } from 'pages/admin/InboundMails/AdminInboundMailsPage/route';
import { adminIngestionHubNewRoute } from 'pages/admin/IngestionsHub/AdminIngestionsHubNewPage/route';
import { adminIngestionsHubRoute } from 'pages/admin/IngestionsHub/AdminIngestionsHubPage/route';
import { adminKopilotInvoiceRoute } from 'pages/admin/KopilotInvoices/AdminKopilotInvoicePage/route';
import { adminKopilotInvoicesRoute } from 'pages/admin/KopilotInvoices/AdminKopilotInvoicesPage/route';
import { adminKopilotValidatedInvoicesRoute } from 'pages/admin/KopilotInvoices/AdminKopilotValidatedInvoicesPage/route';
import { adminLabNewRoute } from 'pages/admin/Labs/AdminLabNewPage/route';
import { adminLabRoute } from 'pages/admin/Labs/AdminLabPage/route';
import { adminLabsRoute } from 'pages/admin/Labs/AdminLabsPage/route';
import { adminLabTradesRoute } from 'pages/admin/LabTrades/AdminLabTradesPage/route';
import { adminEditKonnectTradeRoute } from 'pages/admin/LabTrades/Konnect/AdminEditKonnectTradePage/route';
import { adminKonnectTradesRoute } from 'pages/admin/LabTrades/Konnect/AdminKonnectTradesPage/route';
import { legacyAdminKopilotRedirectRoutes } from 'pages/admin/legacyKopilotRedirectRoutes';
import {
  adminManualValidationTradesParticipationsRoute,
  adminManualValidationTradesRoute,
  adminManualValidationTradesValidationsRoute,
} from 'pages/admin/ManualValidationTrades/route';
import { adminMarketingToolNewRoute } from 'pages/admin/MarketingTools/AdminMarketingToolNewPage/route';
import { adminMarketingToolRoute } from 'pages/admin/MarketingTools/AdminMarketingToolPage/route';
import { adminMarketingToolsRoute } from 'pages/admin/MarketingTools/AdminMarketingToolsPage/route';
import { adminPaymentsRoute } from 'pages/admin/Payments/AdminPaymentsPage/route';
import { adminPharmaciesRoute } from 'pages/admin/Pharmacies/AdminPharmaciesPage/route';
import { adminPharmaciesNewRoute } from 'pages/admin/Pharmacies/AdminPharmacyNewPage/route';
import { adminPharmacyRoute } from 'pages/admin/Pharmacies/AdminPharmacyPage/route';
import { adminPharmaciesMergeRoute } from 'pages/admin/PharmaciesMerge/AdminPharmaciesMergePage/route';
import { adminReferentialPharmaciesRoute } from 'pages/admin/ReferentialPharmacies/AdminReferentialPharmaciesPage/route';
import { adminSelloutPanelistGeneratorRoute } from 'pages/admin/SelloutPanelistGenerator/AdminSelloutPanelistGeneratorPage/route';
import { adminPromptInstructionsRoute } from 'pages/admin/Settings/route';
import { adminTradeRoute } from 'pages/admin/Trades/AdminTradePage/route';
import { adminTradesRoute } from 'pages/admin/Trades/AdminTradesPage/route';
import { adminTradeInstanceRoute } from 'pages/admin/TradesInstances/AdminTradeInstancePage/route';
import { adminTradesInstancesRoute } from 'pages/admin/TradesInstances/AdminTradesInstancesPage/route';
import { adminUserRoute } from 'pages/admin/Users/AdminUserPage/route';
import { adminUsersRoute } from 'pages/admin/Users/AdminUsersPage/route';
import { groupClaimRoute } from 'pages/group/Claims/GroupClaimPage/route';
import { groupClaimsRoute } from 'pages/group/Claims/GroupClaimsPage/route';
import { groupDashboardRoute } from 'pages/group/Dashboard/route';
import { groupEditRoute } from 'pages/group/Edit/GroupEditPage/route';
import { groupGroupsLabsEditRoute } from 'pages/group/GroupsLabs/GroupGroupsLabsEditPage/route';
import { groupGroupsLabsRoute } from 'pages/group/GroupsLabs/GroupGroupsLabsPage/route';
import { groupIndexRoute, groupParentRoute } from 'pages/group/groupParentRoute';
import { groupPharmaciesRoute } from 'pages/group/Pharmacies/GroupPharmaciesPage/route';
import { groupPharmacyEditRoute } from 'pages/group/Pharmacies/GroupPharmacyEditPage/route';
import { groupPharmacyListNewRoute } from 'pages/group/PharmacyLists/PharmacyListIngestionPage/route';
import { groupPharmacyListRoute } from 'pages/group/PharmacyLists/PharmacyListPage/route';
import { groupPharmacyListsRoute } from 'pages/group/PharmacyLists/PharmacyListsPage/route';
import { groupTradeEditRoute } from 'pages/group/Trades/GroupTradeEditPage/route';
import { groupTradeNewRoute } from 'pages/group/Trades/GroupTradeNewPage/route';
import { groupTradeRoute } from 'pages/group/Trades/GroupTradePage/route';
import { groupTradesRoute } from 'pages/group/Trades/GroupTradesPage/route';
import { labClaimRoute } from 'pages/lab/Claims/LabClaimPage/route';
import { labClaimsDashboardRoute } from 'pages/lab/Claims/LabClaimsDashboardPage/route';
import { labClaimsRoute } from 'pages/lab/Claims/LabClaimsPage/route';
import { labEditRoute } from 'pages/lab/Edit/LabEditPage/route';
import { labExpiredProductsRequestRoute } from 'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestPage/route';
import { labExpiredProductsRequestsDashboardRoute } from 'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestsDashboardPage/route';
import { labExpiredProductsRequestsRoute } from 'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestsPage/route';
import { labGroupsLabEditRoute } from 'pages/lab/GroupsLabs/LabGroupsLabEditPage/route';
import { labGroupsLabsRoute } from 'pages/lab/GroupsLabs/LabGroupsLabsPage/route';
import { labGuideItemEditRoute } from 'pages/lab/GuideItems/LabGuideItemEditPage/route';
import { labGuideItemNewRoute } from 'pages/lab/GuideItems/LabGuideItemNewPage/route';
import { labGuideItemsRoute } from 'pages/lab/GuideItems/LabGuideItemsPage/route';
import { labExpiredParentRoute, labIndexRoute, labParentRoute } from 'pages/lab/labParentRoute';
import { labPharmaciesRoute } from 'pages/lab/Pharmacies/PharmaciesPage/route';
import { labPharmacyRoute } from 'pages/lab/Pharmacies/PharmacyPage/route';
import { labPharmacyListNewRoute } from 'pages/lab/PharmacyLists/LabPharmacyListNewPage/route';
import { labPharmacyListRoute } from 'pages/lab/PharmacyLists/LabPharmacyListPage/route';
import { labPharmacyListsRoute } from 'pages/lab/PharmacyLists/LabPharmacyListsPage/route';
import { labRegionEditRoute } from 'pages/lab/Regions/LabRegionEditPage/route';
import { labRegionNewRoute } from 'pages/lab/Regions/LabRegionNewPage/route';
import { labTopicEditRoute } from 'pages/lab/Topics/LabTopicEditPage/route';
import { labTopicNewRoute } from 'pages/lab/Topics/LabTopicNewPage/route';
import { labTradesDashboardRoute } from 'pages/lab/Trades/Dashboard/LabTradesDashboardPage/route';
import { labMasterTradeNewRoute } from 'pages/lab/Trades/LabMasterTrades/LabMasterTradeNewPage/route';
import { labMasterTradeWizardRoute } from 'pages/lab/Trades/LabMasterTrades/LabMasterTradeNewPageV3/route';
import { labMasterTradeRoute } from 'pages/lab/Trades/LabMasterTrades/LabMasterTradePage/route';
import { labMasterTradesRoute } from 'pages/lab/Trades/LabMasterTrades/LabMasterTradesPage/route';
import { labTradesInstancesRoute } from 'pages/lab/Trades/LabTradeInstances/LabTradeInstancesPage/route';
import { onboarderCaptchasRoute } from 'pages/onboarder/CaptchasPage/route';
import { onboarderPharmaciesRoute } from 'pages/onboarder/OnboarderPharmaciesPage/route';
import { onboarderPharmacyEditRoute } from 'pages/onboarder/OnboarderPharmacyEditPage/route';
import { onboarderIndexRoute, onboarderParentRoute } from 'pages/onboarder/onboarderParentRoute';
import { pharmacyAppointmentNotesRoute } from 'pages/pharmacy/AppointmentNotes/route';
import { pharmacyInitiateClaimRoute } from 'pages/pharmacy/Cases/Claims/InitiatePharmacyClaimPage/route';
import { pharmacyClaimNewRoute } from 'pages/pharmacy/Cases/Claims/PharmacyClaimNewPage/route';
import { pharmacyClaimRoute } from 'pages/pharmacy/Cases/Claims/PharmacyClaimPage/route';
import PharmacyExpiredProductsRequestRoleSwitch from 'pages/pharmacy/Cases/ExpiredProductsRequests/PharmacyExpiredProductsRequestPage/PharmacyExpiredProductsRequestRoleSwitch';
import { pharmacyExpiredProductsRequestRoute } from 'pages/pharmacy/Cases/ExpiredProductsRequests/PharmacyExpiredProductsRequestPage/route';
import { pharmacyClaimsRoute } from 'pages/pharmacy/Cases/PharmacyCasesPage/route';
import { pharmacyCompensationsRoute } from 'pages/pharmacy/Compensations/PharmacyCompensationsPage/route';
import {
  pharmacyKopilotInvoiceDetailRoute,
  pharmacyKopilotInvoicesRoute,
} from 'pages/pharmacy/KopilotInvoices/route';
import {
  pharmacyLabInvoiceDetailRoute,
  pharmacyLabRoute,
} from 'pages/pharmacy/Labs/PharmacyLabPage/route';
import { pharmacyLabsRoute } from 'pages/pharmacy/Labs/PharmacyLabsPage/route';
import { legacyKopilotRedirectRoutes } from 'pages/pharmacy/legacyKopilotRedirectRoutes';
import { legacySettingsRedirectRoutes } from 'pages/pharmacy/legacySettingsRedirectRoutes';
import { pharmacyIndexRoute, pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { pharmacyLabDiscussionRoute } from 'pages/pharmacy/SalesRepDiscussions/SalesRepDiscussionPage/route';
import { pharmacyLabsDiscussionsRoute } from 'pages/pharmacy/SalesRepDiscussions/SalesRepDiscussionsPage/route';
import { settingsRoute } from 'pages/pharmacy/Settings/settingsRoutes';
import { pharmacyStripeBillingFormRoute } from 'pages/pharmacy/Stripe/PharmacyStripeBillingFormPage/route';
import { attachDigiAccountingDocumentRoute } from 'pages/pharmacy/Trades/AttachAccountingDocument/route';
import { pharmacyTradeNewRoute } from 'pages/pharmacy/Trades/PharmacyTradeNewPage/route';
import { pharmacyTradeRoute } from 'pages/pharmacy/Trades/TradePage/route';
import { pharmacyTradesRoute } from 'pages/pharmacy/Trades/TradesPage/route';
import { redirectTradeRoute } from 'pages/redirect/RedirectTrade/route';
import { labOldSecuredClaimRoute } from 'pages/secured/Claims/OldSecuredLabClaimPage/route';
import { securedLabClaimRoute } from 'pages/secured/Claims/SecuredLabClaimPage/route';
import { securedParentRoute } from 'pages/secured/securedParentRoute';
import { documentSigningSuccessRoute } from 'pages/shared/DocumentSigningSuccessPage/route';
import { loginPasswordEditRoute } from 'pages/shared/EditPassword/route';
import { emailConfirmationRoute } from 'pages/shared/EmailConfirmation/route';
import DefaultErrorPage from 'pages/shared/errors/DefaultErrorPage';
import { unauthorizedRoute } from 'pages/shared/errors/Page403/route';
import Page404 from 'pages/shared/errors/Page404/Page404';
import { notFoundRoute } from 'pages/shared/errors/Page404/route';
import { invalidTokenRoute } from 'pages/shared/errors/Page498/route';
import { errorRoute } from 'pages/shared/errors/Page500/route';
import { loginFromIdentityProviderRoute } from 'pages/shared/Login/FromIdentityProvider/route';
import { loginFromTokenRoute } from 'pages/shared/Login/FromToken/route';
import { loginInvitationRoute } from 'pages/shared/Login/Invitation/route';
import { loginIndexRoute, loginParentRoute } from 'pages/shared/Login/loginParentRoute';
import { loginCodeRoute } from 'pages/shared/Login/VerifyCode/route';
import { loginEmailRoute } from 'pages/shared/Login/VerifyEmail/route';
import { loginPhoneRoute } from 'pages/shared/Login/VerifyPhoneNumber/route';
import { onboardingCreatePharmacyRoute } from 'pages/shared/Onboarding/CreatePharmacy/route';
import { onboardingCreateProfileRoute } from 'pages/shared/Onboarding/CreateProfile/route';
import { onboardingJoinPharmacyRoute } from 'pages/shared/Onboarding/JoinPharmacy/route';
import { onboardingLabUnavailableRoute } from 'pages/shared/Onboarding/LabUnavailable/route';
import {
  onboardingIndexRoute,
  onboardingParentRoute,
} from 'pages/shared/Onboarding/onboardingParentRoute';
import { onboardingPharmacistOrLabRoute } from 'pages/shared/Onboarding/PharmacistOrLab/route';
import { onboardingSearchPharmacyRoute } from 'pages/shared/Onboarding/SearchPharmacy/route';
import { onboardingVerifyAccountRoute } from 'pages/shared/Onboarding/VerifyAccount/route';
import { onboardingVerifyEmailRoute } from 'pages/shared/Onboarding/VerifyEmail/route';
import { openAppRoute } from 'pages/shared/OpenAppPage/route';
import { outsideFaksSignatureRoute } from 'pages/shared/OutsideFaksSignaturePage/route';
import { pmsActivationRoute } from 'pages/shared/PmsActivationPage/route';
import { editCurrentPharmacyRoute } from 'pages/shared/Profile/PharmacyPage/route';
import { editCurrentUserRoute } from 'pages/shared/Profile/ProfilePage/route';
import { loginPasswordResetRoute } from 'pages/shared/ResetPassword/SendEmail/route';
import { stripeStateRoute } from 'pages/shared/StripeStatePage/route';
import { strongAuthenticationRoute } from 'pages/shared/StrongAuthentication/route';
import { verifyPharmacyEmailRoute } from 'pages/shared/VerifyPharmacyEmailPage/route';
import { z } from 'zod';
import RootNavigate from './RootNavigate';
import { rootRoute } from './rootRoute';
import { canAccessPharmacyPages, WithEnsure, zodPathParamId } from './routeUtils';

const rootIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: RootNavigate,
  pendingComponent: LoadingScreen,
});

const pharmaciesExpiredRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessPharmacyPages, <PharmacyExpiredProductsRequestRoleSwitch />),
  path: '/pharmacies/$pharmacy_id/expired_products_request/$id',
  params: z.object({ pharmacy_id: zodPathParamId, id: zodPathParamId }),
});

const securedAccessTradesRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/securedaccess/trades',
  component: () => <Navigate to="/lab/trades/list" />,
});

const catchAllRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: () => <Navigate to="/" />,
});

const routeTree = rootRoute.addChildren([
  rootIndexRoute,
  adminParentRoute.addChildren([
    adminIndexRoute,
    adminHomeRoute,
    adminFaksRoute,
    adminTasksRoute,
    adminInboundMailsRoute,
    adminClaimRelaunchPlansRoute,
    adminClaimRelaunchPlanNewRoute,
    adminClaimRelaunchPlanEditRoute,
    adminExpiredProductsRequestsRoute,
    adminExpiredProductsRequestRoute,
    adminGroupsRoute,
    adminGroupNewRoute,
    adminGroupRoute,
    adminClaimsRoute,
    adminClaimRoute,
    adminLabsRoute,
    adminLabNewRoute,
    adminLabRoute,
    adminLabTradesRoute,
    adminKonnectTradesRoute,
    adminEditKonnectTradeRoute,
    adminPharmaciesRoute,
    adminPharmacyRoute,
    adminPharmaciesNewRoute,
    adminDatamatrixRoute,
    adminAiPromptRoute,
    adminGroupsLabsRoute,
    adminImpersonateRoute,
    adminIngestionsHubRoute,
    adminIngestionHubNewRoute,
    adminPaymentsRoute,
    adminMarketingToolsRoute,
    adminMarketingToolRoute,
    adminMarketingToolNewRoute,
    adminPharmaciesMergeRoute,
    adminReferentialPharmaciesRoute,
    adminSelloutPanelistGeneratorRoute,
    adminTradesRoute,
    adminTradeRoute,
    adminTradesInstancesRoute,
    adminTradeInstanceRoute,
    adminUsersRoute,
    adminUserRoute,
    adminKopilotInvoicesRoute,
    adminKopilotInvoiceRoute,
    adminKopilotValidatedInvoicesRoute,
    ...legacyAdminKopilotRedirectRoutes,
    adminPromptInstructionsRoute,
    adminAppointmentNoteTemplatesRoute,
    adminManualValidationTradesRoute,
    adminManualValidationTradesParticipationsRoute,
    adminManualValidationTradesValidationsRoute,
  ]),
  onboarderParentRoute.addChildren([
    onboarderIndexRoute,
    onboarderPharmaciesRoute,
    onboarderPharmacyEditRoute,
    onboarderCaptchasRoute,
  ]),
  loginParentRoute.addChildren([
    loginIndexRoute,
    loginEmailRoute,
    loginPhoneRoute,
    loginCodeRoute,
    loginInvitationRoute,
    loginFromTokenRoute,
    loginFromIdentityProviderRoute,
    loginPasswordResetRoute,
    loginPasswordEditRoute,
  ]),
  strongAuthenticationRoute,
  onboardingParentRoute.addChildren([
    onboardingIndexRoute,
    onboardingPharmacistOrLabRoute,
    onboardingLabUnavailableRoute,
    onboardingCreateProfileRoute,
    onboardingSearchPharmacyRoute,
    onboardingCreatePharmacyRoute,
    onboardingJoinPharmacyRoute,
    onboardingVerifyEmailRoute,
    onboardingVerifyAccountRoute,
  ]),
  groupParentRoute.addChildren([
    groupDashboardRoute,
    groupPharmaciesRoute,
    groupPharmacyEditRoute,
    groupPharmacyListsRoute,
    groupPharmacyListNewRoute,
    groupPharmacyListRoute,
    groupClaimsRoute,
    groupClaimRoute,
    groupGroupsLabsRoute,
    groupGroupsLabsEditRoute,
    groupTradesRoute,
    groupTradeRoute,
    groupTradeNewRoute,
    groupTradeEditRoute,
    groupEditRoute,
    groupIndexRoute,
  ]),
  labParentRoute.addChildren([
    labTradesDashboardRoute,
    labTradesInstancesRoute,
    labMasterTradesRoute,
    labMasterTradeNewRoute,
    labMasterTradeWizardRoute,
    labMasterTradeRoute,
    labClaimsDashboardRoute,
    labClaimsRoute,
    labClaimRoute,
    labGroupsLabsRoute,
    labGroupsLabEditRoute,
    labPharmaciesRoute,
    labPharmacyRoute,
    labGuideItemsRoute,
    labGuideItemNewRoute,
    labGuideItemEditRoute,
    labRegionNewRoute,
    labRegionEditRoute,
    labExpiredParentRoute.addChildren([
      labExpiredProductsRequestsDashboardRoute,
      labExpiredProductsRequestsRoute,
      labExpiredProductsRequestRoute,
    ]),
    labEditRoute,
    labTopicNewRoute,
    labTopicEditRoute,
    labPharmacyListsRoute,
    labPharmacyListNewRoute,
    labPharmacyListRoute,
    labIndexRoute,
  ]),
  securedAccessTradesRedirectRoute,
  securedParentRoute.addChildren([securedLabClaimRoute]),
  pharmacyParentRoute.addChildren([
    pharmacyClaimsRoute,
    pharmacyInitiateClaimRoute,
    pharmacyClaimNewRoute,
    pharmacyClaimRoute,
    pharmacyTradesRoute,
    pharmacyTradeRoute,
    pharmacyTradeNewRoute,
    pharmacyStripeBillingFormRoute,
    pharmacyLabsDiscussionsRoute,
    pharmacyLabDiscussionRoute,
    pharmacyLabsRoute,
    pharmacyLabRoute.addChildren([pharmacyLabInvoiceDetailRoute]),
    pharmacyExpiredProductsRequestRoute,
    settingsRoute,
    pharmacyCompensationsRoute,
    pharmacyKopilotInvoicesRoute.addChildren([pharmacyKopilotInvoiceDetailRoute]),
    pharmacyAppointmentNotesRoute,
    ...legacySettingsRedirectRoutes,
    ...legacyKopilotRedirectRoutes,
    pharmacyIndexRoute,
  ]),
  pharmaciesExpiredRedirectRoute,
  // Shared routes
  notFoundRoute,
  unauthorizedRoute,
  invalidTokenRoute,
  errorRoute,
  verifyPharmacyEmailRoute,
  pmsActivationRoute,
  emailConfirmationRoute,
  editCurrentPharmacyRoute,
  editCurrentUserRoute,
  stripeStateRoute,
  documentSigningSuccessRoute,
  openAppRoute,
  outsideFaksSignatureRoute,
  labOldSecuredClaimRoute,
  // Redirect routes
  redirectTradeRoute,
  attachDigiAccountingDocumentRoute,
  catchAllRoute,
]);

export const router = createRouter({
  routeTree,
  context: {
    redirectUrl: null,
  },
  defaultErrorComponent: DefaultErrorPage,
  defaultNotFoundComponent: Page404,
  defaultPendingComponent: LoadingPage,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    fullScreen?: boolean;
  }
}

declare module '@tanstack/history' {
  interface HistoryState {
    // Ordered invoice ids handed to the admin invoice show page from its index,
    // so the page can navigate to the previous/next invoice. Absent on direct load.
    invoiceIds?: number[];
  }
}
